import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';

const technologyMaintenance = [
  {
    'name': 'Parámetros',
    'path': paths.ParametersList,
    'resource': resources.ParametersList,
    'scopes': [scopes.See],
    'icon': 'parameterConfig',
  },
  {
    'name': 'Usuarios',
    'path': paths.UsersList,
    'resource': resources.UsersList,
    'scopes': [scopes.See],
    'icon': 'parameterConfig',
  },
  {
    'name': 'Grupos de Correo',
    'path': paths.MailGroupList,
    'resource': resources.MailGroups,
    'scopes': [scopes.See],
    'icon': 'parameterConfig',
  },
];


const getTechnologyIncomingOptions = (permissions) => {
  const options = [{
    'name': 'Mantenimiento',
    'options': filterByPermissions(permissions, technologyMaintenance),
  }];

  return options.filter((item) => item.options.length);
};

export const getTechnologyOptions = (permissions) => {
  const options = [{
    'name': 'Entrada',
    'options': getTechnologyIncomingOptions(permissions),
  }];

  return options.filter((item) => item.options.length);
};

export const technologyOptions = [...technologyMaintenance];
